import { render } from "./CouponsFilter.vue?vue&type=template&id=6aa7cfa4&scoped=true&ts=true"
import script from "./CouponsFilter.vue?vue&type=script&lang=ts"
export * from "./CouponsFilter.vue?vue&type=script&lang=ts"

import "./CouponsFilter.vue?vue&type=style&index=0&id=6aa7cfa4&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa7cfa4"]])

export default __exports__